export const convertDateFormatForCalendar = (calendarEvent) => {
  calendarEvent.start = new Date(calendarEvent.start);
  calendarEvent.end = new Date(calendarEvent.end);

  return calendarEvent;
};

export const basicDateFormat = 'DD-MMM-YYYY'; // 15-MAR-2024
export const basicDateTimeFormat = 'DD-MMM-YYYY HH:mm:ss';

export const normalDateFormat = 'MM/DD/YYYY';

export const formatDateToYYYYMMDD = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
